<!--Element多选树形控件-->
<template>
  <div class="el_Tree_Body" :style="bodyStyle">
    <div class="elTree_hideButton">
      <div class="elTree_hideButton1" v-show="isShow" @click="isShow=!isShow">
        <el-button size="mini" icon="iconfont iconleft_shousuo"></el-button>
      </div>
      <div class="elTree_hideButton2" v-show="!isShow" @click="isShow=!isShow">
        <el-button size="mini" icon="iconfont iconrigth_shousuo"></el-button>
      </div>
    </div>
    <transition name="el-zoom-in-center">
      <div v-show="isShow" class="elTree_body">
        <h2 style="display: flex;padding-top:10px;align-items: center;">{{columns}}</h2>
        <div style="display: flex;align-items: center;">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small" style='width: 180px;margin-left: 15px;'>
          </el-input>
        </div>
        <div class="scroll" style="height:100%;width: 100%;">
          <el-scrollbar style="height:95%;width: 100%;">
            <!--2020-10-13 lxk 去掉:default-checked-keys="defaultDeviceList"和:default-expanded-keys="defaultDeviceList"-->
            <!--<el-tree :data="data" :expand-on-click-node="false" show-checkbox node-key="pkid" :accordion="true" :default-expanded-keys="defaultDeviceList" :default-checked-keys="defaultDeviceList" :props="defaultProps" @check-change="nodeClick" :highlight-current='true'  :filter-node-method="filterNode" ref="tree">-->
            <!--			<el-tree  :data="data" :expand-on-click-node="true"  show-checkbox node-key="no"  :default-checked-keys="checkedData" :accordion="true" :props="defaultProps" @check-change="nodeClick" :highlight-current='true' :filter-node-method="filterNode" ref="tree">-->
            <el-tree :data="data" :expand-on-click-node="true" show-checkbox node-key="no"
              :default-expanded-keys="checkedData" :default-checked-keys="checkedData" :accordion="true"
              :props="defaultProps" @check="nodeClick" :highlight-current='true' :filter-node-method="filterNode"
              ref="tree">
              <span class="custom-tree-node" slot-scope="{node}">
                <img src="../../../../public/static/image/elTree/1.9.png"
                  v-show="node.data.type=='group'&&node.data.unitid!=''" />
                <img src="../../../../public/static/image/elTree/2.0.png"
                  v-show="node.data.type=='group'&&node.data.unitid==''" />
                <img src="../../../../public/static/image/elTree/2.1.png" v-show="node.data.type=='virtualDevice'" />
                <span style="padding-left: 5px;" @click="spanClick(node)">{{node.label }}</span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  export default {
    components: {},
    props: {
      defaultChecked: {
        type: Array,
        required: false,
        default: () => []
      },
      dataList: {
        type: Array,
        required: true,
        default: []

      },
      columns: ""
    },
    data () {
      return {
        deviceArr: '',
        filterText: '',
        data: [],
        checkedData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        defaultDevice: {},
        isShow: true,
      }
    },
    created () {

    },
    mounted () {
      if(this.dataList.length) {
        this.digui(this.dataList);
      }

      if(!isempty(this.dataList)) {

        this.checkedData=[]
        this.data=this.dataList
        let data1=this.checkedFirst(this.data);
        if(data1!=undefined) {
          this.checkedData.push(data1);
          this.$nextTick(() => {
            this.nodeClick();
          })
        }
      }
    },
    activated () {
      let tempList=[];
      this.$emit('checkItem',tempList)
      this.$store.deviceStore.commit('setNowVirtualDeviceList',tempList)
      let list=this.$refs.tree.getCheckedNodes()
    },
    destroyed () {},
    computed: {
      bodyStyle () {
        let width='0px'
        if(this.isShow) {
          width='2.5rem'
        }
        return {
          "width": width
        }
      },
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      nowVirtualDeviceList () {
        return this.$store.deviceStore.state.nowVirtualDeviceList
      },

      defaultDeviceList () {
        let list=this.nowVirtualDeviceList
        let listDevice=[]
        let idList=[]
        if(isempty(list)) {
          if(!isempty(this.dataList)) {
            this.digui(this.dataList)
          }
        } else {
          list.forEach(item => {
            listDevice.push(item)
            idList.push(item.pkid)
          })
        }
        if(!isempty(idList)) {
          this.$emit('checkItem',listDevice)
        }
        return idList
      }
    },
    watch: {
      filterText (val) {
        //debugger
        this.$refs.tree.filter(val);
      },
      dataList (nv,ov) {
        if(JSON.stringify(nv)==JSON.stringify(ov)) {
          return
        }
        if(!isempty(nv)) {
          this.checkedData=[]
          this.data=this.dataList
          let data1=this.checkedFirst(this.data);
          if(data1!=undefined) {
            this.checkedData.push(data1);
            this.$nextTick(() => {
              this.nodeClick();
            })
          }
        }
      }
    },
    methods: {
      digui (data) {
        this.defaultExpanded=[]
        // console.log("递归的数据",data);
        var device=[]
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.hasOwnProperty('children')&&row.children.length!=0) {
                getStr(row.children)
              } else {
                device.push(row)

              }
            })
          }
          getStr(data)
        }
        recursiveFunction()
        device[0].name=device[0].label
        console.log("device[0]",device[0]);
        this.deviceArr=device
        this.defaultExpanded.push(device[0].pkid)
        this.defaultDevice=device[0].pkid
        this.$nextTick(() => {
          //默认选中

          this.$refs['tree'].setCurrentKey(this.defaultDevice);
        })
        this.$emit('checkItem',device[0])
        this.$store.deviceStore.commit('setNowVirtualDevice',device[0])
      },
      setNowDefaultDevice (id) {
        this.$nextTick(() => {

          if(id) {
            this.checkedData=typeof id=='number'? [id]:id.split(',');
            this.$refs['tree'].setCheckedKeys(this.checkedData);
          }

        })

        // var arr=this.deviceArr.filter(item => item.id==id)
        // arr[0].name=arr[0].label
        // this.defaultDevice=arr[0].pkid
        // this.defaultExpanded.push(arr[0].pkid)

      },
      spanClick (v) {
      },
      filterNode (value,data) {
        //debugger
        if(!value) return true;
        return data.label.indexOf(value)!==-1;
      },
      bindunBeforUnload () {
        //debugger
        let tempList=[];
        this.$emit('checkItem',tempList)
        this.$store.deviceStore.commit('setNowVirtualDeviceList',tempList)
        let list=this.$refs.tree.getCheckedNodes()
      },
      nodeClick () {
        let list=this.$refs.tree.getCheckedNodes()
        list.forEach(item => {
          item.name=item.label
        })
        this.$emit('checkItem',list)
        this.$store.deviceStore.commit('setNowVirtualDeviceList',list)
      },
      // digui (list) {
      //   //debugger
      //   list.forEach(item => {
      //     if(!isempty(item.children)) {
      //       this.digui(item.children)
      //     } else {
      //       if(item.type=='virtualDevice') {
      //         if(isempty(this.nowVirtualDeviceList)) {
      //           this.$store.deviceStore.commit('setNowVirtualDeviceList',[item])
      //         }
      //       }
      //     }
      //   })
      // },
      checkedFirst (list) {
        //debugger
        // console.log("递归方法")
        for(let i=0;i<list.length;i++) {
          let item=list[i];
          if(item.entityName=='VirtualDevicePojo') {
            // return {
            // 	device: item,
            // 	floor: [this.getIdMethod(item)]
            // }
            return item.no
          } else if(!isempty(item.children)) {
            let obj=this.checkedFirst(item.children);
            if(obj!=undefined) {
              //obj.floor.push(this.getIdMethod(item));
              return obj
            }
          }
        }
      },
      getIdMethod (item) {
        if(item.type=="group") {
          return item.id+'_'+item.type
        } else if(item.entityName=='AppClassType') {
          return item.id+'_'+item.type
        }
        return ''
      },
    }
  }
</script>

<style scoped>
  .el-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .el-scrollbar__wrap .el-scrollbar__view {
    white-space: nowrap;
    display: inline-block;
  }
</style>